import PostListComponent from '../../postAdmin/PostListComponent';

const PostsCustomer = () => {

  return (  
      <PostListComponent
        route={`/dashboard/postDashboard`}
      />
  ); 
};

export default PostsCustomer;
 
